import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: () =>
    api
      .send({
        query: gql`
          query documentoOtrosCargos {
            TYPES {
              OtrosCargos {
                readAll {
                  id
                  value
                  annotation
                }
              }
            }
          }
        `,
      })
      .then((result) => result.data.data.TYPES.OtrosCargos.readAll),
};
